import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';
import './index.css';
import logo from '../../imagens/newlogo.png';

const Home = () => {
  const { setUserInfo } = useUser();
  const [empresa, setEmpresa] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [cnpj, setCnpj] = useState('');
  const [modalLoading, setModalLoading] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const navigate = useNavigate();
  const url = 'https://api.wensystem.com.br';

  const empresaInputRef = useRef(null);

  useEffect(() => {
    const savedEmpresa = localStorage.getItem('empresa');
    const savedUsername = localStorage.getItem('username');
    const savedPassword = localStorage.getItem('password');

    if (savedEmpresa && savedUsername && savedPassword) {
      setEmpresa(savedEmpresa);
      setUsername(savedUsername);
      setPassword(savedPassword);
      setRemember(true);
    }

    if (empresaInputRef.current) {
      empresaInputRef.current.focus();
    }
  }, []);

  // Formata CNPJ enquanto o usuário digita
  const formatCNPJ = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 14);
    return digits
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{0,2})/, '$1.$2.$3/$4-$5');
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    const cleanCnpj = cnpj.replace(/\D/g, '');

    if (cleanCnpj.length !== 14) {
      setModalMessage('⚠️ Informe um CNPJ válido com 14 dígitos.');
      return;
    }

    setModalLoading(true);
    setModalMessage('');

    try {
      const response = await fetch(`${url}/recuperar-senha/v1`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cnpj: cleanCnpj }),
      });

      if (response.ok) {
        setModalMessage('✅ Um link de recuperação foi enviado para o e-mail cadastrado.');
        setCnpj('');
      } else {
        setModalMessage('❌ CNPJ não encontrado. Verifique e tente novamente.');
      }
    } catch (error) {
      setModalMessage('❌ Erro ao processar solicitação. Tente novamente.');
    } finally {
      setModalLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setModalMessage('');
    setCnpj('');
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const upperUsername = username.toUpperCase();

      if (!upperUsername || !password) {
        alert('Por favor, preencha todos os campos.');
        return;
      }

      if (remember) {
        localStorage.setItem('empresa', empresa);
        localStorage.setItem('username', upperUsername);
        localStorage.setItem('password', password);
      } else {
        localStorage.removeItem('empresa');
        localStorage.removeItem('username');
        localStorage.removeItem('password');
      }

      const credentials = btoa(`${empresa};${upperUsername}:${password}`);
      const response = await fetch(url + '/login/v1', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'empresa': empresa,
          'Authorization': `Basic ${credentials}`,
        },
      });

      if (response.ok) {
        const data = await response.json();

        if (Array.isArray(data) && data.length > 0 && data[0].login) {
          if (data[0].login === 'Login realizado com sucesso!') {
            setUserInfo({
              username: data[0].nome,
              company: data[0].empresa,
              ven_id: data[0].venId,
              venLogin: data[0].venLogin,
              venSenha: data[0].venSenha,
              url: url,
              alias: empresa,
            });
            navigate('/venda');
          } else {
            alert('Login falhou. Por favor, verifique suas credenciais.');
          }
        } else {
          alert('Login ou senha inexistente. Por favor, tente novamente.');
        }
      } else {
        alert('Falha ao fazer login. Por favor, tente novamente.');
      }
    } catch (error) {
      alert('Ocorreu um erro ao fazer login. Por favor, tente novamente.');
    }
  };

  return (
    <div className="login-container">
      <img src={logo} alt="Logo" className="login-logo" />
      <h1>WEN PDV</h1>
      <form onSubmit={handleLogin} className="login-form">
        <input
          ref={empresaInputRef}
          type="text"
          placeholder="CNPJ da Empresa"
          value={empresa}
          onChange={(e) => {
            const value = e.target.value
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .replace(/\s+/g, '')
              .toUpperCase();
            setEmpresa(value);
          }}
          required
          autoComplete="organization"
        />

        <input
          type="text"
          placeholder="Nome do Usuário"
          value={username}
          onChange={(e) => setUsername(e.target.value.toUpperCase())}
          required
          autoComplete="username"
        />

        <div className="password-wrapper">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            className="eye-icon"
          >
            {showPassword ? '🙈' : '👁️'}
          </span>
        </div>

        <label className="remember-me">
          <input
            type="checkbox"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
          />{' '}
          Lembrar dados
        </label>

        <button type="submit">Login</button>

        {/* Link "Esqueci minha senha" */}
        <button
          type="button"
          className="forgot-password-link"
          onClick={() => setShowModal(true)}
        >
          Esqueci minha senha
        </button>

        {/* Pagina contabilidade" */}
        <button
          type="button"
          className="forgot-password-link"
          onClick={() => navigate('contabilidade')}
        >
          Acesso Contabilidade aos XMLs
        </button>
      </form>

      {/* Modal de Recuperação de Senha */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              ✕
            </button>
            <h2>Recuperar Senha</h2>
            <p>Informe o CNPJ da empresa para receber um link de recuperação no e-mail cadastrado.</p>
            <form onSubmit={handleForgotPassword}>
              <input
                type="text"
                placeholder="00.000.000/0000-00"
                value={cnpj}
                onChange={(e) => setCnpj(formatCNPJ(e.target.value))}
                maxLength={18}
                required
                autoFocus
              />
              {modalMessage && <p className="modal-message">{modalMessage}</p>}
              <button type="submit" disabled={modalLoading}>
                {modalLoading ? 'Enviando...' : 'Enviar Link'}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;